import React from 'react';
import Component from './Component';

const fields = {
  component: Component,
};

const sections = {}

class Registry {
  static getField(type = '', readOnly =  false) {
    const Field = fields[type] || fields.basic;

    if(readOnly) {
      return (props) => <Field {...props} disabled={true}/>
    }
    return Field;
  }

  static addField(type, component) {
    //TODO: validate name
    fields[type] = component;
  }

  static getAllFields() {
    return Object.values(fields);
  }

  static getSection(type = '') {
    let Component = sections[type];

    if(!type || !Component) {
      return sections.Fields;
    }
    return Component;
  }

  static getAllSections() {
    return Object.values(sections);
  }

  static addSection(type, component) {
    sections[type] = component;
  }
}

export default Registry;